module.exports = __webpack_public_path__ + "static/media/FPI-and-me-de-program.2a21bc0c.png";